
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import React from "react";
import useTranslation from "next-translate/useTranslation";
import Trans from "next-translate/Trans";

import { Converter } from "@/containers/Converter";
import { Head } from "@/components/Head";
import { useTheme } from "@/hooks/useTheme";

import { MagicianSection } from "@/sections/MagicianSection";
import { TrustedBySection } from "@/sections/TrustedBySection";
import { SelectFormatSection } from "@/sections/SelectFormatSection";
import { CTASection } from "@/sections/CTASection";
import { ApiTeaserSection } from "@/sections/ApiTeaserSection";
import { ConversionSection } from "@/sections/ConversionSection";

const XDToJPG = () => {
  const { t } = useTranslation();
  const { colors } = useTheme();

  return (
    <>
      <Head
        pageNamespace="page/XDToJPG"
        ogImage="/images/xd2jpg-og-image.jpg"
      />

      <MagicianSection
        title={t("page/XDToJPG:title")}
        subtitle={t("page/XDToJPG:subtitle")}
        magicianLogoFile="jpg"
        cta={{
          title: t("section/magicians:seeHowItWorks"),
          scrollToId: "ApiTeaserSection",
        }}
      >
        <Converter disabled />
      </MagicianSection>

      <TrustedBySection />

      <ApiTeaserSection
        title={
          ((
            <Trans
              i18nKey="page/XDToJPG:section/apiTeaser.title"
              components={[<span style={{ color: colors.ORANGE }} key={0} />]}
            />
          ) as unknown) as string
        }
        image={{
          src: "/images/xd-to-jpg-example.png",
          alt: "Adobe XD to JPG converter example",
        }}
        backgroundColor={colors.LIGHT_GRAY1}
        cta={{
          title: t("common:actions.doNow", { do: t("common:actions.convert") }),
        }}
        elements={t("page/XDToJPG:section/apiTeaser.apiTeaserElements", null, {
          returnObjects: true,
        })}
      />

      <ConversionSection
        title={t("section/conversion:title")}
        iconBadges={[
          {
            iconType: "SHEETS",
            text: t("page/XDToJPG:section/conversion.supportsGroupLayers"),
          },
          {
            iconType: "SYNC-ICON",
            text: t(
              "page/XDToJPG:section/conversion.convertsComponentsSymbols",
            ),
          },
          {
            iconType: "TV",
            text: t("page/XDToJPG:section/conversion.artboardStyleSupport"),
          },
        ]}
        elements={{
          from: {
            iconType: "ADOBEXD",
            image: "/images/xd2jpg-xd-preview.jpg",
            title: "Adobe XD Demo Preview",
          },
          to: {
            iconType: "JPG-ICON",
            image: "/images/xd2jpg-jpg-preview.jpg",
            title: "JPG Demo Preview",
          },
        }}
      />

      <SelectFormatSection title={t("section/selectFormat:title")} />

      <CTASection
        title={t("section/cta:titles.xdToJpgPage")}
        href="#upload"
        isBetaFormat
      />
    </>
  );
};

// Temporal workaround for https://github.com/vercel/next.js/discussions/18396
 async function _getStaticProps() {
  return {
    props: {},
  };
}

export default XDToJPG;


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        let res = _getStaticProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/converter/xd-to-jpg',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  